import { createFileRoute, Link } from '@tanstack/react-router'

import { GroupLabel } from '@/components/GroupLabel'

/**
 * Two styleguides, because there are two visual languages.
 *
 * Internal follows the viewer's theme and is built from tokens; Customer and
 * Public are one fixed light editorial surface. Showing them on one page would
 * put a dark navy control beside a white one and teach neither.
 */
function StyleguideIndex() {
  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-6 p-10">
      <GroupLabel>Styleguides</GroupLabel>
      <Link
        to="/styleguide/internal"
        className="rounded-lg border border-border bg-card p-5 hover:border-primary/40"
      >
        <span className="block text-[15px] font-semibold text-foreground">
          Internal
        </span>
        <span className="mt-1 block text-[12.5px] text-muted-foreground">
          Der Baukasten des Mitarbeiterbereichs — Tokens, hell und dunkel.
        </span>
      </Link>
      <Link
        to="/styleguide/customer"
        className="rounded-lg border border-border bg-card p-5 hover:border-primary/40"
      >
        <span className="block text-[15px] font-semibold text-foreground">
          Customer &amp; Public
        </span>
        <span className="mt-1 block text-[12.5px] text-muted-foreground">
          Die redaktionelle Fläche, die Kund:innen und Besucher:innen sehen.
        </span>
      </Link>
    </div>
  )
}

export const Route = createFileRoute('/styleguide/')({
  component: StyleguideIndex,
})
